import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { DateSelectOption } from '../DateSelectOption'
import { MonthDays } from '../MonthDays'

import * as styles from './DateSelectOptions.module.css'

function DateSelectOptions({
  Component = MonthDays,
  Item = DateSelectOption,
  className = styles.DateSelectOptions,
  disabled,
  itemProps: {
    className: itemClassName = styles.item,
    ...itemProps
  } = EMPTY_OBJECT,
  maxValue,
  minValue,
  rangeEnd,
  rangeHoverEnd,
  rangeStart,
  selected = EMPTY_LIST,
  onRangeHoverEndChange,
  onSelect,
  ...componentProps
}) {
  function handleItemAction(itemValue) {
    onSelect?.(itemValue)
  }

  return (
    <Component
      {...componentProps}
      Item={Item}
      className={className}
      itemProps={{
        ...itemProps,
        className: itemClassName,
        disabled,
        maxValue,
        minValue,
        rangeEnd,
        rangeHoverEnd,
        rangeStart,
        selected,
        onAction: handleItemAction,
        onRangeHoverEndChange,
      }}
    />
  )
}

export default DateSelectOptions
